import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";

/**
 * Interval options in seconds for NB-IoT sensor configuration.
 * Maps to Dragino TDC/MESSION commands.
 */
const INTERVAL_OPTIONS = [
  { value: 300, labelKey: "interval_5min" },
  { value: 600, labelKey: "interval_10min" },
  { value: 900, labelKey: "interval_15min" },
  { value: 1800, labelKey: "interval_30min" },
  { value: 3600, labelKey: "interval_1h" },
  { value: 7200, labelKey: "interval_2h" },
  { value: 14400, labelKey: "interval_4h" },
  { value: 21600, labelKey: "interval_6h" },
  { value: 43200, labelKey: "interval_12h" },
  { value: 86400, labelKey: "interval_24h" },
];

/**
 * Dropdown component for selecting sensor send/measurement intervals.
 *
 * @param {Object} props
 * @param {number|null} props.value - Current interval value in seconds
 * @param {function} props.onChange - Callback when interval changes (receives value in seconds)
 * @param {boolean} props.disabled - Whether the input is disabled
 * @param {string} props.id - HTML id for the select element
 */
export default function IntervalInput({ value, onChange, disabled = false, id }) {
  const { t } = useTranslation();

  const handleChange = (e) => {
    const newValue = e.target.value ? parseInt(e.target.value, 10) : null;
    onChange(newValue);
  };

  return (
    <Form.Select
      id={id}
      value={value || ""}
      onChange={handleChange}
      disabled={disabled}
      size="sm"
      style={{ maxWidth: "150px" }}
    >
      <option value="">—</option>
      {INTERVAL_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {t(option.labelKey)}
        </option>
      ))}
    </Form.Select>
  );
}
